import * as angular from 'angular'

import * as webserviceModels from '../shared/interfaces/webservice-models'
import { DomainListService, ToastHelperService } from '../shared/services'

export class DomainCreateController {
  static $inject = ['$scope', '$mdDialog', 'domainListService', 'gettextCatalog', 'toastHelper', 'punycodeFilter']

  constructor(
    private $scope: IDomainCreateScope,
    private $mdDialog: ng.material.IDialogService,
    private domainListService: DomainListService,
    private gettextCatalog: any,
    private toastHelper: ToastHelperService,
    private punycodeFilter: (...args) => string,
  ) {
    $scope.domainListService = domainListService

    $scope.request = {
      domain: {
        locked: true,
        name: undefined,
        status: 'active',
        type: 'production',
      },
    }
  }

  submit(request: webserviceModels.Common.Request.Domain.adddomain) {
    this.domainListService.create(request).then(
      (success) => {
        this.$mdDialog.hide()
        this.toastHelper.toast(
          this.gettextCatalog.getString('{{domainname}} was successfully created.', {
            domainname: this.punycodeFilter(request.domain.name, 'toUnicode'),
          }),
          this.gettextCatalog.getString('Dismiss'),
        )
      },
      (error) => {
        this.toastHelper.toast(
          error ||
            this.gettextCatalog.getString('{{domainname}} could not be created at this time.', {
              domainname: this.punycodeFilter(request.domain.name, 'toUnicode'),
            }),
          this.gettextCatalog.getString('Dismiss'),
        )
      },
    )
  }

  cancel() {
    this.$mdDialog.cancel()
  }

  setSubmitted(form: ng.IFormController) {
    form.$setSubmitted()

    angular.forEach(form, (item) => {
      if (item && item.$$parentForm === form && item.$setSubmitted) {
        this.setSubmitted(item)
      }
    })
  }
}

export interface IDomainCreateScope extends ng.IScope {
  request: webserviceModels.Common.Request.Domain.adddomain
  domainListService: DomainListService
}
